import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Icon } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { REACT_TABLE_ROW_COLORS } from 'Common/Constants';
import { Base64Image } from 'Common/Components/Base64Image/Base64Image';
import {
  IngredientFieldEnum as Fields,
  RecipeFieldEnum as RecipeFields,
} from 'Common/FieldEnum';
import ReactTable from 'Common/ReactTableWrapper';
import {
  ReactTableWrapperColumnProperties,
  NOTIFICATION_DIALOG_MESSAGES,
} from 'Common/Constants';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
// import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import { CreateEditDupOrderEnum } from 'Common/Constants/Enumeration/ManageIngredientEnum';
import { COMPONENTS } from 'Common/Components/NutritionalHover/constants/constants';
import { SelectFilter, PopupTextCell } from 'Common/GridHelper';
import { ADD_INGREDIENT_HEADER, SELECT_FAT_HEADER } from '../helpers/constants';
import {
  getIngredientSources,
  deleteIngredient,
  clearErrors,
  setDeleteSuccessful,
} from 'Pages/manageingredient/state/editingredient/actions';
import * as EditIngredientSelectors from 'Pages/manageingredient/state/editingredient/selectors';
import * as PagingSelectors from 'State/paging/selectors';
import * as PagingActions from 'State/paging/actions';
import * as PagingConstants from 'State/paging/constants';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { createToast, toastType } from 'Common/ToastHelper';
import { isReadOnly } from '../../manageingredient/helpers/ingredient';
class IngredientTable extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    data: PropTypes.array,
    additionalColumns: PropTypes.array,
    openItemInModal: PropTypes.bool,
    openIngredientModal: PropTypes.func,
    closeTableModal: PropTypes.func,
    hideOptionsMenu: PropTypes.bool,
  };

  static defaultProps = {
    loading: false,
    data: [],
    additionalColumns: [],
    openItemInModal: false,
    hideOptionsMenu: false,
  };

  constructor(props) {
    super(props);

    var additionalColumnsAtStart = [];
    var additionalColumnsAtEnd = [];
    props.additionalColumns.forEach((column) => {
      if (_.isUndefined(column.addToEnd) || column.addToEnd === false) {
        additionalColumnsAtStart.push(column);
      } else {
        additionalColumnsAtEnd.push(column);
      }
    });

    this.allColumns = [
      ...additionalColumnsAtStart,
      ...this.columns,
      ...additionalColumnsAtEnd,
      this.gridControlColumn,
    ];
  }

  componentDidMount() {
    this.props.getIngredientSources();
  }

  componentDidUpdate(prevProps) {
    const { recipesWithIngredient: prevRecipesWithIngredient } = prevProps;
    const {
      recipesWithIngredient,
      setNotificationDialog,
      deleteSuccessful,
      search,
      setDeleteSuccessful,
    } = this.props;
    if (
      prevRecipesWithIngredient !== recipesWithIngredient &&
      recipesWithIngredient.length
    ) {
      const message = (
        <div>
          <p>
            <strong>
              You must first remove this ingredient from the following recipes:
            </strong>
          </p>
          {recipesWithIngredient.map((recipe) => (
            <p style={{ margin: 2 }} key={recipe[RecipeFields.Id]}>
              {recipe[RecipeFields.Id]} - {recipe[RecipeFields.Description]}
              {recipe[RecipeFields.IsFat] && ' (From Fat)'}
            </p>
          ))}
        </div>
      );

      setNotificationDialog({
        ...NOTIFICATION_DIALOG_MESSAGES.INGREDIENT_USED_ON_RECIPES,
        message,
        actionsToDispatchOnOk: [clearErrors()],
      });
    }

    if (deleteSuccessful) {
      setDeleteSuccessful(null);
      createToast(toastType.success, 'Success', 'Ingredient Deleted.');
      search(true);
    }
  }

  onEditIngredientClick = (row) => {
    const { history, openItemInModal, openIngredientModal, closeTableModal } =
      this.props;
    if (openItemInModal) {
      // open in modal
      openIngredientModal(row.Id, closeTableModal);
    } else {
      history.push(
        `/manageingredient/edit/${CreateEditDupOrderEnum.EDIT}/${row.Id}`
      );
    }
  };

  onDuplicateIngredientClick = (row) => {
    const { setNotificationDialog } = this.props;

    setNotificationDialog({
      ...NOTIFICATION_DIALOG_MESSAGES.DUPLICATE_INGREDIENT,
      message: `Are you sure you want to duplicate ${
        row[Fields.IngredientName]
      }?`,
      functionsToRunOnOk: [() => this.duplicateIngredient(row)],
    });
  };

  duplicateIngredient = (row) => {
    const { history } = this.props;

    history.push(
      `/manageingredient/edit/${CreateEditDupOrderEnum.DUP}/${row.Id}`
    );
  };

  onDeleteIngredientClick = (row) => {
    const { setNotificationDialog } = this.props;
    setNotificationDialog({
      ...NOTIFICATION_DIALOG_MESSAGES.DELETE_INGREDIENT,
      actionsToDispatchOnOk: [deleteIngredient(row[Fields.Id])],
    });
  };

  isDeleteOptionDisabled = (row) => {
    const { ingredientSourcesMap } = this.props;
    return isReadOnly(ingredientSourcesMap, row);
  };

  menuOptions = [
    ...(this.props.hideOptionsMenu
      ? []
      : [
          {
            icon: 'pencil',
            text: 'View/Edit',
            handler: this.onEditIngredientClick,
          },
          {
            icon: 'copy',
            text: 'Duplicate',
            handler: this.onDuplicateIngredientClick,
          },
          ...(this.props.handleRemoveReplaceClick
            ? [
                {
                  icon: 'exchange',
                  text: 'Remove/Replace',
                  handler: this.props.handleRemoveReplaceClick,
                },
              ]
            : []),
          {
            icon: 'trash',
            text: 'Delete',
            className: 'danger',
            handler: this.onDeleteIngredientClick,
            disabledWhen: (x) => this.isDeleteOptionDisabled(x),
          },
        ]),
  ];

  columns = [
    {
      Header: 'Images',
      accessor: Fields.Picture,
      style: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      Cell: ({ value }) => (
        <Base64Image style={{ height: 25, width: 'auto' }} fluid src={value} />
      ),
      width: 80,
      sortable: false,
      filterable: false,
      resizable: false,
      show: true,
      visibility: true,
    },
    {
      id: 'Description',
      Header: 'Ingredient Name',
      accessor: Fields.IngredientName,
      Cell: ({ original }) => {
        const value = original[Fields.IngredientName];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Purchased Product Name',
      accessor: Fields.PurchasedProductName,
      Cell: ({ original }) => {
        const value = original[Fields.PurchasedProductName];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
    },
    {
      id: 'ManufactName',
      Header: 'Manufacturer',
      accessor: Fields.Manufacturer,
      Cell: ({ original }) => {
        const value = original[Fields.Manufacturer];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
    },
    {
      id: 'ManufacturerProductCode',
      Header: 'Manufacturer Product Code',
      accessor: Fields.ManufacturerProductCode,
      Cell: ({ original }) => {
        const value = original[Fields.ManufacturerProductCode];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
    },
    {
      id: 'DistributorCode',
      Header: 'Distributor Code',
      accessor: Fields.DistributorCode,
      Cell: ({ original }) => {
        const value = original[Fields.DistributorCode];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'ID/CN Code',
      accessor: Fields.CN_Code,
      Cell: ({ original }) => {
        const value = original[Fields.CN_Code];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Commodity or Recipe Code',
      accessor: Fields.CommodityRecipeCode,
      Cell: ({ original }) => {
        const value = original[Fields.CommodityRecipeCode];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
      show: false,
    },
    {
      id: 'SourceDesc',
      Header: 'Source',
      accessor: Fields.SourceDesc,
      Filter: (props) => (
        <SelectFilter
          usePortal
          {...props}
          options={this.props.sourcesOptions}
        />
      ),
      Cell: ({ original }) => {
        const value = original[Fields.SourceDesc];
        return <PopupTextCell text={value} />;
      },
      width: 140,
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: 'Group',
      accessor: Fields.Group,
      Cell: ({ original }) => {
        const value = original[Fields.Group];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
      show: false,
    },
    ...Object.entries(COMPONENTS).map(([key, value]) => ({
      Header: value,
      accessor: key,
      ...ReactTableWrapperColumnProperties,
      show: false,
    })),
    {
      Header: 'Used in a Recipe',
      accessor: Fields.UsedInRecipe,
      style: {
        textAlign: 'center',
      },
      Cell: ({ original }) => {
        const verified = original[Fields.UsedInRecipe];
        return verified && <Icon size="small" color="green" name="check" />;
      },
      ...ReactTableWrapperColumnProperties,
      show: false,
      filterable: false,
    },
    {
      Header: 'Allergens Verified',
      accessor: Fields.AllergensVerified,
      style: {
        textAlign: 'center',
      },
      Cell: ({ original }) => {
        const verified = original[Fields.AllergensVerified];
        return verified && <Icon size="small" color="green" name="check" />;
      },
      ...ReactTableWrapperColumnProperties,
      show: false,
      filterable: false,
    },
    {
      Header: 'Account Category',
      accessor: Fields.AccountCategory,
      Cell: ({ original }) => {
        const value = original[Fields.AccountCategory];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
      show: false,
    },
    {
      Header: 'Distributor',
      accessor: Fields.Distributor,
      Cell: ({ original }) => {
        const value = original[Fields.Distributor];
        return <PopupTextCell text={value} />;
      },
      ...ReactTableWrapperColumnProperties,
      show: false,
    },
  ];

  gridControlColumn = {
    width: 50,
    fixed: 'right',
    Cell: (gridProps) => {
      if (!this.props.disableViewEdit) {
        return GridContextMenu({
          gridProps,
          options: this.menuOptions,
        });
      } else {
        return GridContextMenu({
          gridProps,
          options: [],
        });
      }
    },
  };

  getTrProps = (state, rowInfo, column) => {
    const style = {};
    const isInactive = _.get(rowInfo, ['original', Fields.Inactive]) === true;
    if (_.get(rowInfo, ['original', Fields.UsedOnMenu]) === true) {
      style.color = REACT_TABLE_ROW_COLORS.USED_ON_MENU;
    }

    if (isInactive) {
      style.color = REACT_TABLE_ROW_COLORS.INACTIVE;
    }

    return {
      style,
    };
  };

  render() {
    const { data, loading, additionalColumns, ...rest } = this.props;

    return (
      <ReactTable
        className="-striped -highlight"
        // saveState={{ tableName: TableNamesEnum.MNU_INGREDIENT_SEARCH_TABLE }}
        gridName={GridEnum.MNU_Ingredient_Table_View}
        loading={loading}
        data={data}
        columns={this.allColumns}
        draggableColumns={true}
        showHideColumn={true}
        menu="hasCogs"
        getTrProps={this.getTrProps}
        {...rest}
      />
    );
  }
}

/**
 *
 * @param {Component} WrappedComponent
 * @param {Object} options
 * @param {Boolean} options.searchOnMount - determines whether the the ingredients api will be called on wrapped component mount
 * @param {Boolean} options.refreshTotalPages - determines whether the pagination api should send TotalPages as 0
 * @param {Boolean} options.useSecondaryPaging - determines whether the pagination api should use the primary or secondary paging state
 */
const withIngredientApi = (
  WrappedComponent,
  options = {
    searchOnMount: false,
    refreshTotalPages: false,
    useSecondaryPaging: false,
  }
) => {
  class WithIngredientApi extends React.Component {
    static propTypes = {
      searchParameters: PropTypes.shape({
        Search: PropTypes.string,
        ShowInvLinked: PropTypes.bool,
        ShowInactive: PropTypes.bool,
        SearchCycleMenu: PropTypes.bool,
        PopulateMeasures: PropTypes.bool,
        TotalPages: PropTypes.number,
      }),
    };

    static defaultProps = {
      searchParameters: {
        Search: '',
        ShowInvLinked: false,
        ShowInactive: false,
        SearchCycleMenu: false,
        PopulateMeasures: false,
        TotalPages: 1,
      },
    };

    componentDidMount() {
      if (options.searchOnMount) {
        this.search(true);
      }
    }

    componentDidUpdate(prevProps) {
      const {
        searchParameters: prevSearchParameters,
        pageNumber: prevPageNumber,
        pageSize: prevPageSize,
        filter: prevFilter,
        sortColumn: prevSortColumn,
      } = prevProps;
      const { searchParameters, pageNumber, pageSize, filter, sortColumn } =
        this.props;

      const isSameSearchParameters = _.isEqual(
        searchParameters,
        prevSearchParameters
      );

      let shouldDebounce = false;
      let shouldSearch = false;

      if (!isSameSearchParameters) {
        shouldSearch = true;
        if (searchParameters.Search !== prevSearchParameters.Search) {
          // user is searching, should debounce
          shouldDebounce = true;
        }
      }

      if (!_.isEqual(prevFilter, filter)) {
        shouldSearch = true;
        shouldDebounce = true;
      }
      /** pagination/sort/filter parameters have changed */
      if (
        prevPageNumber !== pageNumber ||
        prevPageSize !== pageSize ||
        !_.isEqual(prevSortColumn, sortColumn)
      ) {
        shouldSearch = true;
      }

      if (shouldSearch) {
        shouldDebounce ? this.debouncedSearch() : this.search();
      }
    }

    componentWillUnmount() {
      this.props.reset();
    }

    search = async (refreshTotalPages = false) => {
      const { getPage } = this.props;
      const { searchParameters, pages, headerTitle } = this.props;

      if (
        headerTitle === ADD_INGREDIENT_HEADER ||
        headerTitle === SELECT_FAT_HEADER
      ) {
        searchParameters.PopulateMeasures = true;
        searchParameters.TotalPages = 0;
      } else {
        searchParameters.PopulateMeasures = false;
        if (refreshTotalPages || options.refreshTotalPages) {
          searchParameters.TotalPages = 0;
        } else {
          searchParameters.TotalPages = pages;
        }
      }

      getPage('Ingredient/GetIngredientSearchResults', searchParameters);
    };

    debouncedSearch = _.debounce(this.search, 300);

    render() {
      const {
        data,
        pageNumber,
        hasNextPage,
        pageSize,
        pages,
        loading,
        ...rest
      } = this.props;

      const proxiedProps = {
        data,
        hasNextPage,
        pageSize,
        pages,
        page: pageNumber - 1, // react table uses 0 indexing
        loading,
        search: this.search,
      };
      return <WrappedComponent {...rest} {...proxiedProps} />;
    }
  }

  WithIngredientApi = connect(
    getApiMapStateToProps(options.useSecondaryPaging),
    getApiMapDispatchToProps(options.useSecondaryPaging)
  )(WithIngredientApi);

  return WithIngredientApi;
};

const getApiMapStateToProps = (useSecondaryPaging) => {
  if (useSecondaryPaging) {
    const secondaryPagingSelectors = PagingSelectors.commonStatePagingSelectors(
      PagingConstants.secondaryStateName
    );
    return (state) => ({
      loading: secondaryPagingSelectors.getLoading(state),
      hasNextPage: secondaryPagingSelectors.getHasNextPage(state),
      data: secondaryPagingSelectors.getData(state),
      pages: secondaryPagingSelectors.getPages(state),
      total: secondaryPagingSelectors.getTotal(state),

      pageNumber: secondaryPagingSelectors.getPageNumber(state),
      pageSize: secondaryPagingSelectors.getPageSize(state),
      filter: secondaryPagingSelectors.getFilter(state),
      sortColumn: secondaryPagingSelectors.getSortColumn(state),
    });
  }
  const primaryPagingSelectors = PagingSelectors.commonStatePagingSelectors(
    PagingConstants.primaryStateName
  );
  return (state) => ({
    loading: primaryPagingSelectors.getLoading(state),
    hasNextPage: primaryPagingSelectors.getHasNextPage(state),
    data: primaryPagingSelectors.getData(state),
    pages: primaryPagingSelectors.getPages(state),
    total: primaryPagingSelectors.getTotal(state),

    pageNumber: primaryPagingSelectors.getPageNumber(state),
    pageSize: primaryPagingSelectors.getPageSize(state),
    filter: primaryPagingSelectors.getFilter(state),
    sortColumn: primaryPagingSelectors.getSortColumn(state),
  });
};

const getApiMapDispatchToProps = (useSecondaryPaging) => {
  if (useSecondaryPaging) {
    const secondaryPagingActions = PagingActions.commonStatePagingActions(
      PagingConstants.secondaryPrefix
    );
    return {
      getPage: secondaryPagingActions.getPage,
      reset: secondaryPagingActions.reset,
    };
  }
  const primaryPagingActions = PagingActions.commonStatePagingActions(
    PagingConstants.primaryPrefix
  );
  return {
    getPage: primaryPagingActions.getPage,
    reset: primaryPagingActions.reset,
  };
};

const mapStateToProps = (state) => ({
  sourcesOptions: EditIngredientSelectors.getIngredientSourcesOptions(state),
  ingredientSourcesMap: EditIngredientSelectors.getIngredientSourcesMap(state),
  recipesWithIngredient:
    EditIngredientSelectors.getRecipesWithIngredient(state),
  deleteSuccessful: EditIngredientSelectors.getDeleteSuccessful(state),
});

const mapDispatchToProps = {
  getIngredientSources,
  setNotificationDialog,
  setDeleteSuccessful,
};

IngredientTable = connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(IngredientTable));

export { IngredientTable, withIngredientApi };



// WEBPACK FOOTER //
// ./src/pages/managerecipe/components/IngredientTable.js